/**
 * Apply a percent discount without taking the fare under the class base price.
 * Toll is never discounted. The returned total is the discounted fare plus toll,
 * before GST.
 */
export function discountFareAboveBase(amount, discountPercent, tollAmount = 0, floorPrice = 0) {
  const total = Number(amount);
  const toll = Number(tollAmount);
  const safeToll = Number.isFinite(toll) ? toll : 0;
  if (!Number.isFinite(total)) {
    return { total: 0, discountAmount: 0, effectivePercent: 0, cappedAtBase: false };
  }

  const pct = Number(discountPercent);
  const safePct = Number.isFinite(pct) && pct > 0 ? Math.min(100, pct) : 0;
  const baseFare = total - safeToll;
  if (safePct <= 0) {
    return {
      total: Math.ceil(total),
      discountAmount: 0,
      effectivePercent: 0,
      cappedAtBase: false,
    };
  }

  const rawDiscounted = Math.ceil(baseFare * (1 - safePct / 100));
  let discountedBase = rawDiscounted;
  const floor = Number(floorPrice);
  const safeFloor = Number.isFinite(floor) && floor > 0 ? floor : 0;
  let cappedAtBase = false;
  if (safeFloor > 0 && discountedBase < safeFloor && baseFare >= safeFloor) {
    discountedBase = Math.ceil(safeFloor);
    cappedAtBase = true;
  }

  const fareCeil = Math.ceil(baseFare);
  if (discountedBase > fareCeil) discountedBase = fareCeil;
  if (discountedBase >= fareCeil) {
    return {
      total: Math.ceil(fareCeil + safeToll),
      discountAmount: 0,
      effectivePercent: 0,
      cappedAtBase,
    };
  }

  const discountAmount = fareCeil - discountedBase;
  const effectivePercent = Math.round(((baseFare - discountedBase) / baseFare) * 10000) / 100;
  return {
    total: Math.ceil(discountedBase + safeToll),
    discountAmount,
    effectivePercent,
    cappedAtBase,
  };
}
